import { Injectable } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { DispatchPicklistApprovalDetail } from '../model/dispatch-picklist-approval-detail';
import { catchError, map, Observable, of, tap } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class DispatchPicklistApprovalIndexedDbService {

static readonly STORE_NAME = 'dispatch_picklist_approval';

	constructor(
		private dbService: NgxIndexedDBService
	) {}

	addTransaction(
		outgoing_request_id: string
		, details: DispatchPicklistApprovalDetail[]
	): Observable<DispatchPicklistApprovalIndexedDbObject> {
		const object: DispatchPicklistApprovalIndexedDbObject = {
			outgoing_request_id: outgoing_request_id,
			details: details
		};
		return this.dbService.add(DispatchPicklistApprovalIndexedDbService.STORE_NAME,object)
	}

	saveTransaction(
		outgoing_request_id: string
		, details: DispatchPicklistApprovalDetail[]
	): Observable<DispatchPicklistApprovalIndexedDbObject | null> {
		console.log(details)
		const object: DispatchPicklistApprovalIndexedDbObject = {
			outgoing_request_id: outgoing_request_id,
			details: details
		};
		return this.dbService.update(DispatchPicklistApprovalIndexedDbService.STORE_NAME, object)
			.pipe(
				tap((res) => {console.log(res)}),
				catchError((err) => {
					console.log(err)
					return of(null)
				})
			)
	}

	getTransaction(outgoing_request_id: string): Observable<DispatchPicklistApprovalIndexedDbObject> {
		return this.dbService.getByKey(DispatchPicklistApprovalIndexedDbService.STORE_NAME, outgoing_request_id)
			.pipe(
				map((data: any) => {
					if(data){
						return data;
					}
					return null;
				})
			)
	}

	deleteTransaction(outgoing_request_id: string) : Observable<any>{
		return this.dbService.delete(DispatchPicklistApprovalIndexedDbService.STORE_NAME, outgoing_request_id)
			.pipe(
				tap((res) => {console.log(res)}),
				catchError((err) => {
					console.log(err)
					return of(null)
				})
			)
	}

	clearStore() : Observable<any> {
		return this.dbService.clear(DispatchPicklistApprovalIndexedDbService.STORE_NAME)
	}
}

// Reason why outgoing_request_id is of type string
// Its entry point is from GET query params which always return string
export interface DispatchPicklistApprovalIndexedDbObject {
	outgoing_request_id:string;
	details:DispatchPicklistApprovalDetail[],
}